<template>
	<div class="notes-box">
		注：{{msg}}
	</div>
</template>

<script>
	export default {
		name: 'Notes',
		props: {
			hasPhone: {
				type: Boolean,
				default: true
			}
		},
		computed: {
			msg() {
				return this.hasPhone ? '本机号码一键登陆请先输入手机号码（需关闭wifi状态下操作）' : '本机号码一键验证先关闭Wi-Fi状态下操作'
			}
		}
	}
</script>

<style scoped>
	.notes-box {
		width: 100%;
		color: red;
		align-items: flex-start;
		text-align: left;
		padding-left: 10px;
		font-size: 12px;
		box-sizing: border-box;
	}
</style>
